module.exports = __webpack_public_path__ + "media/images/country_flags/si-4b34440314411c63d9db56c580c3235c.png";